// actions/test-maintenance/initiative.js

import { attachAuth } from '../../utils/authService';

export function initiativeHasErrored(bool) {
  return {
    type: 'INITIATIVE_TEST_M_HAS_ERRORED',
    hasErrored: bool
  };
}

export function initiativeIsLoading(bool) {
  return {
    type: 'INITIATIVE_TEST_M_IS_LOADING',
    isLoading: bool
  };
}

export function initiativeFetchDataSuccess(resp) {
  return {
    type: 'INITIATIVE_TEST_M_FETCH_DATA_SUCCESS',
    resp
  };
}

export function initiativeFetchData(host, body) {
  return (dispatch) => {
    dispatch(initiativeIsLoading(true));
    dispatch(initiativeHasErrored(false));
    fetch(host + 'admin/initiative', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
      
      dispatch(initiativeIsLoading(false));
      promise.json()
        .then(result => {
          dispatch(initiativeFetchDataSuccess(result))
        })
        .catch((e) => {
          console.log(e);
          dispatch(initiativeHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
          dispatch(initiativeIsLoading(false));
          dispatch(initiativeHasErrored(true));
      });
  };
}